import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import styled from 'styled-components';
import FeaturedWiresContext from '../context';
import { useDeleteUnfeatureWire } from '../../../../../../services/wires/featured-wires-service';

const Container = styled(Dropdown)`
  & > button.icon-lw-ellipsis {
    outline: none;
    transform: rotate(90deg);
    border: none;
    background: none;
    color: ${props => props.theme.bodyColor};
    padding: 0 4px 0 0;
    &:hover {
      color: ${props => props.theme.bodyColor};
      border: none;
      background: none;
    }
  }

  & > .dropdown-menu:not(.show) {
    display: none;
  }

  & > .dropdown-menu.show {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 12px 20px;
    background: white;
    border: 1px solid ${props => props.theme.secondaryColorLight};
    border-radius: 3px;
    box-shadow: 0px 16px 24px rgba(50, 50, 71, 0.08), 0px 12px 12px rgba(50, 50, 71, 0.08);
    z-index: 500;

    > .dropdown-item {
      outline: none;
      border: none;
      background: none;
      color: ${props => props.theme.secondaryColor};
      font: ${props => props.theme.fontWeightHeavy} 14px/15px ${props => props.theme.fontFamilyBody};
      text-transform: uppercase;
      margin: 13px 0;
      text-decoration: none;
      :hover {
        text-decoration: none;
      }
    }
  }
`;

export default function Menu({ id, slug }) {
  const { dispatch } = React.useContext(FeaturedWiresContext);
  const [, unfeature] = useDeleteUnfeatureWire(id);

  const change = e => {
    e && e.preventDefault();
    dispatch({ type: 'updateWire', payload: { slug, toChange: true } });
  };

  const remove = e => {
    e && e.preventDefault();
    unfeature().then(() => dispatch({ type: 'removeWire', payload: { slug } }));
  };

  return (
    <Container alignRight>
      <Dropdown.Toggle className="icon-lw icon-lw-ellipsis" id={`drop-down-toggle-for-wire-${slug}`} />
      <Dropdown.Menu alignRight>
        <Dropdown.Item href={`/wires/${slug}`} target="_blank">view wire</Dropdown.Item>
        <Dropdown.Item href="#" onClick={change}>change</Dropdown.Item>
        <Dropdown.Item href="#" onClick={remove}>remove</Dropdown.Item>
      </Dropdown.Menu>
    </Container>
  );
}

Menu.propTypes = {
  slug: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
};
